import {getCookie, setCookie} from "../Plugins/Cookies";
import PageLoadedQueue from "../PageLoadedQueue";
import {RenderModal} from "../Functions/RenderModal";

/**
 * Initialize popups
 */
export function initializePopups() {
    const popupWrappers: NodeListOf<HTMLElement> = document.querySelectorAll('.popup-wrapper');

    popupWrappers.forEach((popupWrapper) => {
        const popup: HTMLElement = popupWrapper.querySelector('.popup');
        const identifier = popup.dataset.identifier;
        const popupCookie = getCookie('PopupCookie-' + identifier);

        if (!popupCookie) {
            const popupContent = popupWrapper.innerHTML;

            const bootbox = RenderModal.init('', popupContent)[0];
            bootbox.querySelector('.modal-body').addEventListener('click', () => {
                setCookie('PopupCookie-' + identifier, true);
            });
        }
    });
}

PageLoadedQueue.addFunction(initializePopups);
